import IGoogleMapPosition from '../../../types/IGoogleMapPosition';
import { BloczekMarker } from '../../../types/marker/BloczekMarker';

const getMarkerPosition = (marker: BloczekMarker): IGoogleMapPosition => ({
  lat: marker.SzerokoscGeo,
  lng: marker.DlugoscGeo,
});
export default getMarkerPosition;
